import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { primeQueryCache } from "../../../utils/primeQueryCache";
import { ArticleDto } from "../../../models/article/dto/article.dto";
import { GET_ARTICLE_QUERY_KEY } from "./useGetArticle";

export const GET_ARTICLES_QUERY_KEY = (organizationId: string, includeUnpublished?: boolean) => ['articles', 'list', organizationId, includeUnpublished];
export const useListArticles = (organizationId: string, includeUnpublished = false) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: GET_ARTICLES_QUERY_KEY(organizationId, includeUnpublished),
        queryFn: () => client.fetchApi<ArticleDto[], {}>({
            endpoint: `articles/admin/list/all?organizationId=${organizationId}&includeUnpublished=${includeUnpublished}`,
            method: 'GET'
        }),
        enabled: !!organizationId,
        staleTime: 30_000,
        onSuccess: (data: ArticleDto[]) => {
            // O(items), not O(items × cache) — see primeQueryCache for the org-switch freeze this loop was part of.
            primeQueryCache(queryClient, (item) => GET_ARTICLE_QUERY_KEY(item.id), data);
        },
    });
};
